import { render, staticRenderFns } from "./Library.vue?vue&type=template&id=d4a33718&"
import script from "./Library.vue?vue&type=script&lang=js&"
export * from "./Library.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3779005718/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4a33718')) {
      api.createRecord('d4a33718', component.options)
    } else {
      api.reload('d4a33718', component.options)
    }
    module.hot.accept("./Library.vue?vue&type=template&id=d4a33718&", function () {
      api.rerender('d4a33718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Library.vue"
export default component.exports